import React from "react";
import Modal from "./Modal";
import { PhotoBoothSession } from "@mijnfotohoek-types";
import Button from "components/forms/Button";
import firebase from "../../firebase";
import { DashboardContext } from "contexts/DashboardContext";
import { useContext } from "react";
const ModalPhotoBoothSessionArchive = ({
  close,
  session,
}: {
  close: () => void;
  session: PhotoBoothSession;
}) => {
  const [isArchiving, setIsArchiving] = React.useState(false);
  const { sendToast } = useContext(DashboardContext);
  const handleArchive = () => {
    setIsArchiving(true);
    // Implement the archive logic here
    firebase
      .firestore()
      .collection("photo_booth_sessions")
      .doc(session.id)
      .update({ archived: true })
      .then(() => {
        setIsArchiving(false);
        sendToast("Fotohoek succesvol gearchiveerd", "", "success", 3000);
        close();
      })
      .catch(() => {
        sendToast(
          "Er is een fout opgetreden bij het archiveren van de fotohoek",
          "",
          "error",
          3000,
        );
        setIsArchiving(false);
      });
  };

  return (
    <Modal
      close={close}
      width={500}
      title="Fotohoek archiveren"
      description="Weet je zeker dat je deze fotohoek wilt archiveren?De QR-codes zullen actief blijven"
    >
      <div className="flex justify-end gap-4 mt-12">
        <Button color="text-blue-500" onClick={close}>
          Annuleren
        </Button>
        <Button onClick={handleArchive} loading={isArchiving}>
          Archiveren
        </Button>
      </div>
    </Modal>
  );
};

export default ModalPhotoBoothSessionArchive;
